import { Button, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import MarkersTable from "../../Table/MarkersTable/markers-table";
import { DbAssetMarkerInfos } from "../../../Core/Api/Types/db-asset-marker-infos";
import { useTranslation } from "react-i18next";

export type ModalMarkerRevisionReviewElementProps = {
  objectId: number;
  markers: DbAssetMarkerInfos[] | [];
  onConfirm?: () => void;
};

export type ModalMarkerRevisionReviewProps = CommonModalProps<ModalMarkerRevisionReviewElementProps>;

const ModalMarkerRevisionReview = React.forwardRef<any, ModalMarkerRevisionReviewProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onConfirm, ...modalProps } = props;
  const { objectId, markers } = modalProps;

  const handleConfirmClick = () => {
    onConfirm && onConfirm();
    closeModal();
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      title={t("modal:title.revisionReview")}
      reference={ref}
      closeModal={handleCancelClick}
      width={1000}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button color="success" variant="outlined" disabled={false} onClick={handleConfirmClick}>
            {t("button:applyUpdateAndSendNoti")}
          </Button>
        </Stack>
      }
    >
      <Stack>
        <Stack spacing={2} mb={2}>
          <MarkersTable
            objectId={objectId}
            markers={markers}
            playerSeekEnable={false}
            columnVisibilityModel={{ actions: false, comment: false, revision: false }}
          />
        </Stack>
      </Stack>
    </Modal>
  );
});

export default ModalMarkerRevisionReview;
